import type {Dispatch, SetStateAction} from "react";
import {SearchFieldV5} from "../input/search/SearchFieldV5";
import {Functions} from "../../../utils/function/Functions";

interface IViewFindProps {
	readonly viewSearchString: string;
	readonly setViewSearchString: Dispatch<SetStateAction<string>>;
	readonly autoFocus?: boolean;
}

export const ViewFind = (props: IViewFindProps) => {
	const {viewSearchString, setViewSearchString, autoFocus} = props;

	return (
		<SearchFieldV5
			autoFocus={autoFocus}
			value={viewSearchString}
			onInput={setViewSearchString}
			onClick={Functions.stopPropagation}
		/>
	);
};
